module.exports = __webpack_public_path__ + "static/media/16UNODC29.5fc9ef62.jpg";